// test1747
(1747 && 0);
